import { getQuery, insertQuery, updateQuery } from "api/UdasWrapper";
import { addErrorLog } from "../Logger/logger";
import { cacheUpdateSocketIoClient } from "../App";

export const insertConnectorVersion = async (tenant_id, connector_id, config_files, filename, filesize, version, release_notes) => {
   const input = {
               tenant_id,
               connector_id,
               config_files,
               filename,
               filesize,
               version,
               release_notes
            };
   
   let errorMessage;

   try {
      if (cacheUpdateSocketIoClient?.connected) {
         const parameterMatchTest = await cacheUpdateSocketIoClient.emitWithAck("connectorCreation", input);
         
         if (parameterMatchTest === 'ok')
            console.debug(`Passed connector validation in cxf-executor for connector ${input?.connector_id} (${input?.filename}) for tenant ${input?.tenant_id}`);
         else {
            errorMessage = `Connector ${input?.connector_id} (${input?.filename}) for tenant ${input?.tenant_id} did not pass validation: ${parameterMatchTest}`; 
            console.error(errorMessage);
            
            return {
               success: false,
               message: parameterMatchTest
            };
         }
      } else {
         errorMessage = 'Unable to request connector validation in cxf-executor because the service is not running or not reachable'; 
         console.error(errorMessage);
         
         return {
            success: false,
            message: errorMessage
         };
      }
   } catch (error) {
      errorMessage = `Unable to request connector cache update in cxf-executor: ${JSON.stringify(error)}`; 
      console.error(errorMessage);
      
      return {
         success: false,
         message: errorMessage
      };
   }

   try {
      const data = JSON.stringify({
         query: `mutation InsertConnectorVersion($input: ConnectorVersionInput) {
  insertConnectorVersion(input: $input) {
    isSuccessful
    message
    resultObject
  }
}`,
         variables: {
            input
         }
      });
      
      return {
         success: true,
         data: (await insertQuery(data))?.insertConnectorVersion
      };
   } catch (error) {
      addErrorLog("mutation InsertConnectorVersion", error, tenant_id);
      errorMessage = `Unable to insert connector (version) in the cxf-udas service: ${JSON.stringify(error)}`; 
      console.error(errorMessage);
      
      return {
         success: false,
         message: errorMessage
      };
   }
};

export const getConnectorVersions = async (tenant_id, connector_id) => {
   try {
      const data = JSON.stringify({
         query: `query GetConnectorVersions($tenant_id: String!, $connector_id: ID!) {
      getConnectorVersions(tenant_id: $tenant_id, connector_id: $connector_id) {
        isSuccessful
        message
        resultObject
      }
    }`,
         variables: {
            tenant_id,
            connector_id
         }
      });
      const response = await getQuery(data);
      return response?.getConnectorVersions?.resultObject;
   } catch (error) {
      addErrorLog("query GetConnectorVersions", error, tenant_id);
      return null;
   }
};

export const deleteConnectorVersion = async (input) => {
   try {
      const data = JSON.stringify({
         query: `mutation DeleteConnectorVersion($input: DeleteConnectorVersionInput!) {
      deleteConnectorVersion(input: $input) {
        isSuccessful
        message
        resultObject
      }
    }`,
         variables: {
            input
         }
      });
      const response = await getQuery(data);
      return response?.deleteConnectorVersion;
   } catch (error) {
      addErrorLog("mutation DeleteConnectorVersion", error, input.tenant_id);
      return null;
   }
};

export const updateConnectorVersion = async (input, id) => {
   let errorMessage;

   try {
      if (cacheUpdateSocketIoClient?.connected) {
         const parameterMatchTest = await cacheUpdateSocketIoClient.emitWithAck("connectorUpdate", input);
         
         if (parameterMatchTest === 'ok')
            console.debug(`Passed connector validation and updated connector cacche in cxf-executor for connector ${input?.connector_id} (${input?.filename}) for tenant ${input?.tenant_id}`);
         else {
            errorMessage = `Connector ${input?.connector_id} (${input?.filename}) for tenant ${input?.tenant_id} did not pass validation: ${parameterMatchTest}`; 
            console.error(errorMessage);
            
            return {
               success: false,
               message: parameterMatchTest
            };
         }
      } else {
         errorMessage = 'Unable to request connector validation and cache update in cxf-executor because the service is not running or not reachable'; 
         console.error(errorMessage);
         
         return {
            success: false,
            message: errorMessage
         };
      }
   } catch (error) {
      errorMessage = `Unable to request connector cache update in cxf-executor: ${JSON.stringify(error)}`; 
      console.error(errorMessage);
      
      return {
         success: false,
         message: errorMessage
      };
   }

   try {
      const data = JSON.stringify({
         query: `mutation UpdateConnectorVersion($input: ConnectorVersionInput, $id: String!) {
      updateConnectorVersion(input: $input, id: $id) {
        isSuccessful
        message
        resultObject
      }
    }`,
         variables: {
            input,
            id
         }
      });
      
      return {
         success: true,
         data: (await updateQuery(data))?.updateConnectorVersion?.resultObject
      };
   } catch (error) {
      addErrorLog("mutation UpdateConnectorVersion", error);
      errorMessage = `Unable to update connector (version) in the cxf-udas service: ${JSON.stringify(error)}`; 
      console.error(errorMessage);
      
      return {
         success: false,
         message: errorMessage
      };
   }
};
